import { memo, useMemo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useLocation } from "react-router-dom";
import * as Components from "./SettingsMenu.components";

interface SettingsMenuItemProps {
  label: string;
  route?: string;
  component?: React.ForwardRefExoticComponent<React.RefAttributes<HTMLAnchorElement>>;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  disabled?: boolean;
}

function SettingsMenuItem(props: SettingsMenuItemProps) {
  const { route, label } = props;
  const { pathname } = useLocation();

  const isActive = useMemo(() => {
    // No route specified, cannot be active
    if (route === undefined) return false;
    // Special case for settings root path
    if (pathname === "/settings" && route === "") return true;
    // Checks if not /settings and route is root path
    if (pathname !== "/settings" && route === "") return false;

    return pathname.includes(route);
  }, [pathname, route]);

  return (
    <ListItem disablePadding>
      <Components.SettingsListItemButton data-active={isActive} aria-current={isActive ? "page" : undefined} {...props}>
        <ListItemText
          primary={
            <Typography variant="h3" gutterBottom={false}>
              <Box component="span" sx={{ fontWeight: "fontWeightLight" }}>
                {label}
              </Box>
            </Typography>
          }
        />
      </Components.SettingsListItemButton>
    </ListItem>
  );
}

export default memo(SettingsMenuItem);
